import { Menu } from "primereact/menu";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";

import { useLocation, useNavigate } from "react-router";
import { useSidebar } from "../contexts/SidebarContext";
import { useAppDispatch } from "../redux/store";
import { userSlice } from "../redux/slices/user";

export default function SidebarMenu() {
  const dispatch = useAppDispatch();

  const { isSidebarVisible, toggleSidebar } = useSidebar();

  const navigate = useNavigate();
  const location = useLocation();

  const customHeader = <img src="assets/waybiller-logo.svg" alt="logo" />;

  const handleLogout = () => {
    dispatch(userSlice.actions.setToken(null));
    dispatch(userSlice.actions.setUser(null));
    // Clear the auth token from localStorage
    localStorage.removeItem("auth_token");
    // Navigate to the login page
    void navigate("/");
  };

  const items: {
    label: string;
    icon: string;
    command: () => void | Promise<void>;
    className?: string;
    disabled?: boolean;
  }[] = [
    {
      label: "Kontrakty",
      icon: "pi pi-file",
      command: () => navigate("/kontrakty"),
      className: location.pathname === "/kontrakty" ? "active-menu-item" : "",
      disabled: false,
    },
    {
      label: "Towar Do Zabrania",
      icon: "pi pi-warehouse",
      command: () => navigate("/towar-do-zabrania"),
      className:
        location.pathname === "/towar-do-zabrania" ? "active-menu-item" : "",
      disabled: false,
    },
    {
      label: "Zlecenia Transportowe",
      icon: "pi pi-shopping-bag",
      command: () => navigate("/zlecenia-transportowe"),
      className:
        location.pathname === "/zlecenia-transportowe"
          ? "active-menu-item"
          : "",
    },
    {
      label: "Spedycja",
      icon: "pi pi-truck",
      command: () => navigate("/spedycja"),
      className: location.pathname === "/spedycja" ? "active-menu-item" : "",
    },
    {
      label: "Dostawy",
      icon: "pi pi-box",
      command: () => navigate("/dostawy"),
      className: location.pathname === "/dostawy" ? "active-menu-item" : "",
    },
    {
      label: "Kierowca",
      icon: "pi pi-users",
      command: () => navigate("/kierowca"),
      className: location.pathname === "/kierowca" ? "active-menu-item" : "",
    },
    {
      label: "Firmy",
      icon: "pi pi-building",
      command: () => navigate("/firmy"),
      className: location.pathname === "/firmy" ? "active-menu-item" : "",
    },
    {
      label: "Lokalizacje",
      icon: "pi pi-map-marker",
      command: () => navigate("/lokalizacje"),
      className: location.pathname === "/lokalizacje" ? "active-menu-item" : "",
    },
    {
      label: "Towar",
      icon: "pi pi-warehouse",
      command: () => navigate("/towar"),
      className: location.pathname === "/towar" ? "active-menu-item" : "",
    },
    {
      label: "Ustawienia",
      icon: "pi pi-cog",
      command: () => navigate("/ustawienia"),
      className: location.pathname === "/ustawienia" ? "active-menu-item" : "",
      disabled: true,
    },
  ];
  return (
    <Sidebar
      appendTo="self"
      className="layout-sidebar"
      header={customHeader}
      visible={isSidebarVisible}
      onHide={toggleSidebar}
      modal={false}
      dismissable={false}
      closeOnEscape={false}
    >
      <Menu model={items} />
      <Button
        label="Wylogować się"
        onClick={handleLogout}
        className="logout-button"
        icon="pi pi-sign-out"
      />
    </Sidebar>
  );
}
